import type { UseQueryOptions } from '@tanstack/react-query'

import { isAirlockRequestsV3RoutesEnabled } from 'utils/env'

export const withDataAccessRequestsEnabled = (enabled = true): boolean => isAirlockRequestsV3RoutesEnabled() && enabled

/** These hooks combine `enabled` with the feature flag, so they take a boolean instead of v5's callback form. */
export type DataAccessRequestQueryOptions<TData, TError> = Omit<
  UseQueryOptions<TData, TError>,
  'queryKey' | 'enabled'
> & {
  enabled?: boolean
}
